<template>
   <div class="chart-warp">
    <div class="topBox">
      <div class="title">
        <span class=""></span>
        {{name}}
      </div>
      <div class="btn-box">
        <button :class="{'activeBtn':activeBtn===7}" @click="setDay(7)">近一周</button>
        <button :class="{'activeBtn':activeBtn===30}" @click="setDay(30)">近30天</button>
        <button :class="{'activeBtn':activeBtn===365}" @click="setDay(365)">近一年</button>
      </div>
    </div>
    <div :id="id" :style="`height:${height};width:${width};zoom:${zoom};`"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    id: {
      type: String,
      default: "chartMain"
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '290px'
    },
    name: {
      type: String,
      default: ""
    },
    right: {
      type: String,
      default: "10"
    },
    colorStops: {
      type: Object,
      default: () => ({})
    },
    smooth: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    domainCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      myChart: null,
      option: null,
      activeBtn: 7,
      areaStyle: null,
      dataX: [],
      data: [],
      zoom: 1
    };
  },
  watch: {
    domainCode(newValue) {
      console.log(newValue, "newValue");
      this.setDay(this.activeBtn)
      return newValue
    }
  },
  created() {
    if (this.colorStops.start) {
      this.areaStyle = {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: this.colorStops.start // 0% 处的颜色
          }, {
            offset: 1, color: this.colorStops.end // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }
    }

  },
  async mounted() {
    const that = this;
    window.onresize = function () {

    };
    if (window.innerWidth > 992 && window.innerWidth < 1366) {  // zoom 变形处理
      this.zoom = 1.25;
    }
    this.option = {
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [],
        axisTick: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#00E3FF'
          },
          show: true
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            fontSize: 14,
            color: '#454545'
          }
        },

      },
      yAxis: [{
        type: 'value',
        axisTick: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#00E3FF'
          },
          show: true
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            fontSize: 14,
            color: '#454545'
          }
        },
        splitLine: {//分割线配置
          show: true,
          lineStyle: {
            color: "rgba(96, 174, 246,0.5)",
          }
        }
        // minInterval: 1,
        // max:5,
        // min:1,
      }],
      tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        // left: '3%',
        // right: '4%',
        bottom: '3%',
        containLabel: true
      },
      series: [{
        data: [],
        type: 'line',
        smooth: this.smooth,
        areaStyle: this.areaStyle,
        itemStyle: {
          normal: {
            color: this.colorStops.start || '#3486FB',
            borderColor: this.colorStops.start || '#3486FB',
            borderWidth: 12,
            borderColor: this.colorStops.start || '#3486FB',
          }
        },
      }],
      grid: {
        top: 30,
        left: 50,
        right: 20,
        // height: 200
      },
    }

    // await this.getDateRange(this.activeBtn)
    await this.setType(this.type)
    // await this.setDay(this.activeBtn)
    // this.initChart()
  },
  beforeDestroy() {
    this.destroyChart();
    window.onresize = null;
  },
  methods: {
    async setType() {
      let url = "", name, time;
      switch (this.type) {
        case "size":
          url = "/api/v1/taskCost/queryDailyAvg";
          name = "transWordNum";
          time = "transDate"
          break;
        case "speed":
          url = "/api/v1/taskCost/queryDailyAvg";
          name = "transCostTime";
          time = "transDate"
          break;
        case "fluency":
          url = "/api/v1/taskScore/queryDailyAvg";
          name = "fluencyScore";
          time = "taskFinishTime";
          this.option.yAxis[0].max = 5
          break;
        case "accuracy":
          url = "/api/v1/taskScore/queryDailyAvg";
          name = "accuracyScore";
          time = "taskFinishTime";
          this.option.yAxis[0].max = 5
          break;
        default:
          break;
      }
      const params = {
        preDate: this.activeBtn,
        domainCode: this.domainCode,
        userId: this.$route.query.id
      }
      const { result, resultCode } = await this.catReq1Service(url, params)
      if (resultCode === '1') {
        let dataX = [], dataV = [];
        let t = this.activeBtn <= 30 ? 'day' : '';
        result.forEach(item => {
          dataX.push(this.dateReg(item[time], t));
          if (this.type === 'speed') {
            const value = item[name] ? Math.round(item.transWordNum / (item[name] / 60)) : item[name];
            dataV.push({ name: this.dateReg(item[time], t), value });
          } else {
            dataV.push({ name: this.dateReg(item[time], t), value: item[name] });
          }
        });
        this.option.xAxis.data = dataX;
        this.option.series[0].data = dataV;
        console.log(dataV, "////time");
        this.initChart()

      }
    },
    dateReg(str, type) {
      if (type === "day") {
        return str = str.slice(5, 10)
      } else {
        return str.slice(0, 7)
      }

    },
    initChart() {

      let chartDom = document.getElementById(this.id);
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption(this.option);
    },
    destroyChart() {
      if (!this.myChart) {
        return
      }
      this.myChart.dispose()
      this.myChart = null
    },
    async setDay(days) {
      this.activeBtn = days;
      await this.setType()
      // this.dataX = this.getDateRange(days);
    },

    getDateRange(intervalDays) {
      let dateNow = new Date();
      let oneDayTime = 24 * 60 * 60 * 1000;
      let list = [];
      let lastDay;
      for (let index = intervalDays - 1; index >= 1; index--) {
        lastDay = new Date(dateNow.getTime() - index * oneDayTime);
        list.push(this.formateDate(lastDay));
      }
      list.push(this.formateDate(dateNow));
      return list;
    },
    formateDate(time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()

      if (month < 10) {
        month = '0' + month
      }

      if (day < 10) {
        day = '0' + day
      }

      return month + '-' + day + ''

    }
  },
};
</script>

<style lang="less" scoped>
.chart-warp {
  width: 45%;
}
.topBox {
  display: flex;
  justify-content: space-between;
}
.title {
  font-weight: bold;
  color: #454545;
  span {
    display: inline-block;
    width: 4px;
    height: 18px;
    background: linear-gradient(0deg, #37a1f2 0%, #aed0ff 100%);
    border-radius: 2px;
    margin-right: 8px;
  }
}
.btn-box {
  button {
    width: 66px;
    height: 30px;
    line-height: 30px;
    background: #ffffff;
    color: #4095ff;
    border: 1px solid #4095ff;
    border-radius: 6px;
    margin-left: 28px;
  }
  .activeBtn {
    background: #4095ff;
    color: #ffffff;
    border: 1px solid #fff;
  }
}
</style>
